export default __webpack_public_path__ + "static/media/library-white.fd1d7fbb.svg";